export const BASE = 8;
export const HALF_BASE = 4;

/**
 * returns a size in pixels depending on the base value of 8px.
 * The base scale is a multiple of 8, but there's also mid values which add half of the base value (+4).
 *
 * example:
 *    `spacer.x5` returns `40px`: 8 x 5 = 40.
 *    `spacer.x5pt5` returns `44px`: 8 x 5 + 4 = 44.
 *
 * spacer.x0 and spacer.x0pt5 return half the base value, so `4px`
 */
export const spacer = {
  x0: `${BASE / 2}px`,
  x0pt5: `${BASE / 2}px`,
  x1: `${BASE}px`,
  x1pt5: `${BASE + HALF_BASE}px`,
  x2: `${BASE * 2}px`,
  x2pt5: `${BASE * 2 + HALF_BASE}px`,
  x3: `${BASE * 3}px`,
  x3pt5: `${BASE * 3 + HALF_BASE}px`,
  x4: `${BASE * 4}px`,
  x4pt5: `${BASE * 4 + HALF_BASE}px`,
  x5: `${BASE * 5}px`,
  x5pt5: `${BASE * 5 + HALF_BASE}px`,
  x6: `${BASE * 6}px`,
  x6pt5: `${BASE * 6 + HALF_BASE}px`,
  x7: `${BASE * 7}px`,
  x7pt5: `${BASE * 7 + HALF_BASE}px`,
  x8: `${BASE * 8}px`,
  x8pt5: `${BASE * 8 + HALF_BASE}px`,
};
